import React, { forwardRef } from "react";
import PropTypes from 'prop-types';
import { StyledPopupWrapper, StyledPopup } from "./styled";
import Paper from "../Paper";
import { makeStyles } from '../../utils/styles';

const useStyles = makeStyles(css => ({
  content: css`
      padding: 20px 30px;
  `
}));

const Popup = forwardRef(({ open, relatedItem, children, width, positionVertical, positionHorizontal }, ref) => {
  const styles = useStyles();

  return (
    <StyledPopupWrapper
      ref={ref}
    >
      {relatedItem}
      {open &&
        <StyledPopup
          width={width}
          positionVertical={positionVertical}
          positionHorizontal={positionHorizontal}
        >
          <Paper
            customStyle={styles.content}
          >
            {children}
          </Paper>
        </StyledPopup>
      }
    </StyledPopupWrapper>
  );
});

Popup.propTypes = {
  open: PropTypes.bool,
  relatedItem: PropTypes.node,
  children: PropTypes.node,
  width: PropTypes.string,
  positionVertical: PropTypes.oneOf(['top', 'bottom']),
  positionHorizontal: PropTypes.oneOf(['left', 'right']),
};

Popup.defaultProps = {
  open: true,
  width: '450px',
  positionVertical: 'top',
  positionHorizontal: 'left'
};

export default React.memo(Popup);
